// extracted by mini-css-extract-plugin
export default {"innerWrapper":"ww-z","tooltipWrapper":"xw-z","icon":"yw-z","tooltip":"zw-z","content":"Aw-z"};